export default "__VITE_ASSET__6ijxCMFX__"